myMovementsPie
/* @ngInject */
const myMovementsPie = (
  wagonFields
) => {
  return {
    restrict: 'E',
    scope: {

    },
    template: require('./myMovementsPie.html'),
    /* @ngInject */
    controller: ($scope, $$movement, utils) => {
      const init = async () => {
        $scope.labels = utils.date.get12MonthsNameFromNow()
        $scope.series = ['Mouvements', 'Garage', 'Dégarages',]
        $scope.data = [[], [], [],]

        const dates = utils.date.get12MonthsIntervalFromNow()

        const movePromises = []
        const parkPromises = []
        const unparkPromises = []

        for (let i = 0; i < dates.length; i++) {
          const date = dates[i];

          movePromises.push($$movement.request
            .countBySearch({
              move: true,
              dateBegin: utils.date.momentToPHP(date.begin),
              dateEnd: utils.date.momentToPHP(date.end),
            }))

          parkPromises.push($$movement.request
            .countBySearch({
              park: true,
              dateBegin: utils.date.momentToPHP(date.begin),
              dateEnd: utils.date.momentToPHP(date.end),
            }))

          unparkPromises.push($$movement.request
            .countBySearch({
              unpark: true,
              dateBegin: utils.date.momentToPHP(date.begin),
              dateEnd: utils.date.momentToPHP(date.end),
            }))
        }

        $scope.data[0] = await Promise.all(movePromises)
        $scope.data[1] = await Promise.all(parkPromises)
        $scope.data[2] = await Promise.all(unparkPromises)
      }

      init()
    },
    link: {
      pre: (scope, element, attrs) => {  },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}
export default myMovementsPie



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/stat/myMovementsPie.js